module.exports = __webpack_public_path__ + "static/marker-71c806428f9d8c76f8dd491ee177382c.png";